import { createSlice } from '@reduxjs/toolkit'

import { loadConfig, addToCart_aggregated, submitForm_aggregated } from '../requests/thunks'

interface YassState {
  configId: string
  configHashKey: string
  configData: Record<PropertyKey, any> | null
}

const initialState: YassState = {
  // Latest received id and hashKey on load/save
  configId: '',
  configHashKey: '',
  // Latest received config on load
  configData: null, // {}
}

const yassSlice = createSlice({
  name: 'yass',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadConfig.fulfilled, (state, action) => {
        const { yassConfigId, yassConfigHashKey, dmConfigData } = action.payload

        state.configId = yassConfigId
        state.configHashKey = yassConfigHashKey
        state.configData = dmConfigData
      })
      .addCase(loadConfig.rejected, (state) => {
        state.configData = null
      })
      .addCase(addToCart_aggregated.fulfilled, (state, action) => {
        const { _configId, _configHashKey } = action.payload

        state.configId = _configId
        state.configHashKey = _configHashKey
      })
      .addCase(submitForm_aggregated.fulfilled, (state, action) => {
        const { _configId, _configHashKey } = action.payload

        state.configId = _configId
        state.configHashKey = _configHashKey
      })
  },
})

export default yassSlice.reducer
